export default __webpack_public_path__ + "static/TTCommons-Regular-d45540eb1e3ff756679ad25758008b50.ttf";